import {
  SiPython,
  SiGo,
  SiJavascript,
  SiTypescript,
  SiGnubash,
  SiPostgresql,
  SiFastapi,
  SiDjango,
  SiNodedotjs,
  SiExpress,
  SiNextdotjs,
  SiMongodb,
  SiRedis,
  SiElasticsearch,
  SiMysql,
  SiDocker,
  SiKubernetes,
  SiTerraform,
  SiGithub,
  SiPrometheus,
  SiGit,
  SiLinux,
  SiNginx,
  SiGrafana,
  SiPostman,
} from "react-icons/si";
import { skillCategories } from "../data/skills";
import useInView from "../lib/useInView";

const ICON_MAP = {
  SiPython,
  SiGo,
  SiJavascript,
  SiTypescript,
  SiGnubash,
  SiPostgresql,
  SiFastapi,
  SiDjango,
  SiNodedotjs,
  SiExpress,
  SiNextdotjs,
  SiMongodb,
  SiRedis,
  SiElasticsearch,
  SiMysql,
  SiDocker,
  SiKubernetes,
  SiTerraform,
  SiGithub,
  SiPrometheus,
  SiGit,
  SiLinux,
  SiNginx,
  SiGrafana,
  SiPostman,
};

function Badge({ name, icon }) {
  const Icon = icon ? ICON_MAP[icon] : null;
  return (
    <div className="skill-badge flex items-center gap-2 px-3 py-2 rounded-lg border border-[#1e293b] bg-[#111111]">
      {Icon ? (
        <Icon size={15} className="text-[#94a3b8] flex-shrink-0" />
      ) : (
        <span className="font-mono text-indigo-500/60 text-xs">◆</span>
      )}
      <span className="text-sm text-[#f1f5f9] font-medium whitespace-nowrap">
        {name}
      </span>
    </div>
  );
}

function Category({ name, icon, skills, visible, idx }) {
  return (
    <div
      className={`transition-all duration-700 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      style={{ transitionDelay: `${idx * 110}ms` }}
    >
      <div className="flex items-center gap-3 mb-4">
        <span className="font-mono text-indigo-400 text-sm font-semibold">
          {icon}
        </span>
        <h3 className="text-[#f1f5f9] font-semibold text-xs uppercase tracking-widest">
          {name}
        </h3>
        <div className="flex-1 h-px bg-[#1e293b]" />
      </div>
      <div className="flex flex-wrap gap-2">
        {skills.map((s) => (
          <Badge key={s.name} {...s} />
        ))}
      </div>
    </div>
  );
}

export default function Skills() {
  const [ref, visible] = useInView();

  return (
    <section id="skills" className="section-padding bg-[#050505]">
      <div className="section-container" ref={ref}>
        <div
          className={`mb-14 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="section-label">// 03. tech_stack</span>
          <h2 className="section-heading">Skills & Technologies</h2>
          <div className="section-divider" />
          <p className="text-[#94a3b8] max-w-xl">
            Tools and technologies I've worked with extensively in production
            environments.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {skillCategories.map((cat, i) => (
            <Category key={cat.name} {...cat} visible={visible} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
